// stores/statisticsStore.js
import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";

export const useStatisticsStore = defineStore("statistics", () => {
  const isDownloading = ref(false);
  const error = ref(null);

  const downloadStatistics = async (filename) => {
    isDownloading.value = true;
    error.value = null;

    try {
      const response = await axios({
        url: "/api/statistics/download",
        method: "GET",
        params: { filename },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);

      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      return response;
    } catch (err) {
      error.value = err.response?.data?.message || "Error downloading file";
      throw err;
    } finally {
      isDownloading.value = false;
    }
  };

  return {
    isDownloading,
    error,
    downloadStatistics,
  };
});
